import AlertDialog from 'DesignSystem/Overlays/AlertDialog/AlertDialog';
import HTMLLinkDialog from 'DesignSystem/Overlays/HTMLLinkDialog/HTMLLinkDialog';
import ActivitySelectDecisionDialog from 'FeatureModules/Activity/Components/Dialogs/ActivitySelectDecisionDialog';
import AddEditActivityDialog from 'FeatureModules/Activity/Components/Dialogs/AddEditActivityDialog';
import AddEditComponentDialog from 'FeatureModules/ComponentChain/Components/Dialogs/AddEditComponentDialog';
import AddEditFarmPlotsDialog from 'FeatureModules/ComponentChain/Components/Dialogs/AddEditFarmPlotsDialog';
import AddRawMaterialDialog from 'FeatureModules/ComponentChain/Components/Dialogs/AddRawMaterialDialog';
import AddStepsDialog from 'FeatureModules/ComponentChain/Components/Dialogs/AddStepsDialog';
import CopyChainDialog from 'FeatureModules/ComponentChain/Components/Dialogs/CopyChainDialog';
import EditComponentChainDialog from 'FeatureModules/ComponentChain/Components/Dialogs/EditComponentChainDialog';
import EditStepDialog from 'FeatureModules/ComponentChain/Components/Dialogs/EditStepDialog';
import ImportComponentChainsDialog from 'FeatureModules/ComponentChain/Components/Dialogs/ImportComponentChainsDialog';
import SelectActivityDialog from 'FeatureModules/ComponentChain/Components/Dialogs/SelectActivityDialog';
import ConfirmDatasetImportDialog from 'FeatureModules/DataImport/Components/DIalogs/ConfirmDatasetImportDialog';
import ConfirmFarmClusteringDialog from 'FeatureModules/DataImport/Components/DIalogs/ConfirmFarmClusteringDialog';
import CreateDatasetDecisionDialog from 'FeatureModules/DataImport/Components/DIalogs/CreateDatasetDecisionDialog';
import DatasetImportDialog from 'FeatureModules/DataImport/Components/DIalogs/DatasetImportDialog';
import DatasetTableSettingsDialogs from 'FeatureModules/DataImport/Components/DIalogs/DatasetTableSettingsDialogs';
import DownloadGeoDataDialog from 'FeatureModules/DataImport/Components/DIalogs/DownloadGeoDataDialog';
import WktGeometryEditorDialog from 'FeatureModules/DataImport/Components/DIalogs/WktGeometryEditorDialog';
import EditDocumentDialog from 'FeatureModules/Document/Components/Dialogs/EditDocumentDialog';
import SelectDocumentsDialog from 'FeatureModules/Document/Components/Dialogs/SelectDocumentsDialog';
import UploadDocumentDialog from 'FeatureModules/Document/Components/Dialogs/UploadDocumentDialog';
import CreateClaimDialog from 'FeatureModules/ImpactClaim/Components/Dialogs/CreateClaimDialog';
import EditClaimDialog from 'FeatureModules/ImpactClaim/Components/Dialogs/EditClaimDialog';
import RequestClaimDialog from 'FeatureModules/ImpactClaim/Components/Dialogs/RequestClaimDialog';
import AddEditPartnerDialog from 'FeatureModules/Partner/Components/Dialog/AddEditPartnerDialog';
import PartnerResendInviteDialog from 'FeatureModules/Partner/Components/Dialog/PartnerResendInvitationDialog';
import PartnerSelectDecisionDialog from 'FeatureModules/Partner/Components/Dialog/PartnerSelectDecisionDialog';
import {
  PartnerRequestDialog,
  RequestDetailsDialog,
} from 'FeatureModules/Partner/Components/PartnerRequests';
import AddDuplicateEditProductDialog from 'FeatureModules/ProductPage/Components/Dialogs/AddDuplicateEditProductDialog';
import AddLanguageDialog from 'FeatureModules/ProductPage/Components/Dialogs/AddLanguageDialog';
import LanguageSettingDialog from 'FeatureModules/ProductPage/Components/Dialogs/LanguageSettingDialog';
import PublishFinishedDialog from 'FeatureModules/ProductPage/Components/Dialogs/PublishFinishedDialog';
import VisibilitySettingsDialog from 'FeatureModules/ProductPage/Components/Dialogs/VisibilitySettingsDialog';
import AddEditQuestionnaireDialog from 'FeatureModules/Questionnaire/Components/Dialogs/AddEditQuestionnaireDialog';
import PreviewQuestionnaireDialog from 'FeatureModules/Questionnaire/Components/Dialogs/PreviewQuestionnaireDialog';
import ReviewQuestionnaireRequestDialog from 'FeatureModules/Questionnaire/Components/Dialogs/ReviewQuestionnaireRequestDialog';
import AcceptRequestDialog from 'FeatureModules/Request/Components/Dialogs/AcceptRequestDialog';
import DenyRequestDialog from 'FeatureModules/Request/Components/Dialogs/DenyRequestDialog';
import FinishChainRequestDialog from 'FeatureModules/Request/Components/Dialogs/FinishChainRequestDialog';
import ManageRequestDialog from 'FeatureModules/Request/Components/Dialogs/ManageRequestDialog';
import RequestCertificateDialog from 'FeatureModules/Request/Components/Dialogs/RequestCertificateDialog';
import ReviewChainRequestDialog from 'FeatureModules/Request/Components/Dialogs/ReviewChainRequestDialog';
import UploadRequestDialog from 'FeatureModules/Request/Components/Dialogs/UploadDocumentToRequestDialog';
import AddEditFarmPlotDialog from 'FeatureModules/Site/Components/Dialogs/AddEditFarmPlotDialog';
import AddEditSiteClusterDialog from 'FeatureModules/Site/Components/Dialogs/AddEditSiteClusterDialog';
import AddEditSiteDialog from 'FeatureModules/Site/Components/Dialogs/AddEditSiteDialog';
import AddMangeClusterDecisionDialog from 'FeatureModules/Site/Components/Dialogs/AddMangeClusterDecisionDialog';
import DeleteSiteClusterDialog from 'FeatureModules/Site/Components/Dialogs/DeleteSiteClusterDialog';
import ManageClusterSitesDialog from 'FeatureModules/Site/Components/SiteSelectionDialog/ManageClusterSitesDialog';
import ManageSiteDialog from 'FeatureModules/Site/Components/SiteSelectionDialog/ManageSiteDialog';
import React, { ComponentProps, FC, PropsWithChildren, createContext, useState } from 'react';
import { IDefaultDialogProps } from 'types/dialog.types';

/**
 * Whenever you add a new dialog, you need to add it to this object
 * Like this the DialogContext can be used to open any dialog and the props are type safe from the component itself
 * If you do not need to pass any props to the dialog, you can just add the key to the DialogPropsTypeOptional type
 * Please keep them sorted alphabetically to make it easier to find them in the list
 * In visual studio code you can do that by marking all -> press CTRL + SHIFT + P -> Type 'sort ascending'
 */
const DIALOGS = {
  ACTIVITY_SELECT_DECISION: ActivitySelectDecisionDialog,
  ADD_EDIT_ACTIVITY: AddEditActivityDialog,
  ADD_EDIT_COMPONENT: AddEditComponentDialog,
  ADD_EDIT_DUPLICATE_PRODUCT: AddDuplicateEditProductDialog,
  ADD_EDIT_FARM_PLOT: AddEditFarmPlotDialog,
  ADD_EDIT_FARM_PLOTS: AddEditFarmPlotsDialog,
  ADD_EDIT_PARTNER: AddEditPartnerDialog,
  ADD_EDIT_QUESTIONNAIRE: AddEditQuestionnaireDialog,
  ADD_EDIT_SITE_CLUSTER: AddEditSiteClusterDialog,
  ADD_EDIT_SITE: AddEditSiteDialog,
  ADD_LANGUAGE: AddLanguageDialog,
  ADD_MANAGE_CLUSTER_DECISION: AddMangeClusterDecisionDialog,
  ADD_RAW_MATERIAL: AddRawMaterialDialog,
  ADD_STEPS: AddStepsDialog,
  ALERT: AlertDialog, // This generic dialog can be used to confirm any action like deleting an item
  CONFIRM_DATASET_IMPORT: ConfirmDatasetImportDialog,
  CONFIRM_FARM_CLUSTERING: ConfirmFarmClusteringDialog,
  COPY_CHAIN: CopyChainDialog,
  CREATE_DATASET_DECISION: CreateDatasetDecisionDialog,
  CREATE_IMPACT_CLAIM: CreateClaimDialog,
  DATASET_IMPORT: DatasetImportDialog,
  DATASET_TABLE_SETTINGS: DatasetTableSettingsDialogs,
  DELETE_SITE_CLUSTER: DeleteSiteClusterDialog,
  DENY_REQUEST: DenyRequestDialog,
  DOWNLOAD_GEO_DATA: DownloadGeoDataDialog,
  EDIT_CHAIN: EditComponentChainDialog,
  EDIT_DOCUMENT: EditDocumentDialog,
  EDIT_IMPACT_CLAIM: EditClaimDialog,
  EDIT_STEP: EditStepDialog,
  FINISH_CHAIN_REQUEST: FinishChainRequestDialog,
  HTML_LINK: HTMLLinkDialog,
  IMPORT_COMPONENT_CHAINS: ImportComponentChainsDialog,
  LANGUAGE_SETTINGS: LanguageSettingDialog,
  MANAGE_CLUSTER_SITES: ManageClusterSitesDialog,
  MANAGE_REQUEST: ManageRequestDialog,
  MANAGE_SITE: ManageSiteDialog,
  PARTNER_REQUEST: PartnerRequestDialog,
  PARTNER_RESEND_INVITE: PartnerResendInviteDialog,
  PARTNER_SELECT_DECISION: PartnerSelectDecisionDialog,
  PREVIEW_QUESTIONNAIRE: PreviewQuestionnaireDialog,
  PUBLISH_SUCCESS: PublishFinishedDialog,
  REQUEST_CERTIFICATION: RequestCertificateDialog,
  REQUEST_DETAILS: RequestDetailsDialog,
  REQUEST_IMPACT_CLAIM: RequestClaimDialog,
  REVIEW_CHAIN_REQUEST: ReviewChainRequestDialog,
  REVIEW_DOCUMENT_REQUEST: AcceptRequestDialog,
  REVIEW_QUESTIONNAIRE_REQUEST: ReviewQuestionnaireRequestDialog,
  SELECT_DOCUMENTS: SelectDocumentsDialog,
  SELECT_EXISTING_ACTIVITY: SelectActivityDialog,
  UPLOAD_DOCUMENTS: UploadDocumentDialog,
  UPLOAD_REQUEST: UploadRequestDialog,
  VISIBILITY_SETTINGS: VisibilitySettingsDialog,
  WKT_GEOMETRY_EDITOR: WktGeometryEditorDialog,
};

export type TDialogTypes = keyof typeof DIALOGS;

/**
 * Dialogs that do not necessary need the props to be passed
 * will use props?: T instead of props: T
 */
const DIALOG_PROPS_TYPE_OPTIONAL = [
  'ADD_EDIT_PARTNER',
  'ADD_RAW_MATERIAL',
  'ADD_EDIT_SITE_CLUSTER',
  'CREATE_IMPACT_CLAIM',
  'DATASET_IMPORT',
  'PARTNER_REQUEST',
  'PARTNER_SELECT_DECISION',
  'CREATE_DATASET_DECISION',
  'UPLOAD_DOCUMENTS',
  'ADD_EDIT_QUESTIONNAIRE',
] as const satisfies readonly TDialogTypes[];

export type TDialogPropsTypeOptional = (typeof DIALOG_PROPS_TYPE_OPTIONAL)[number];

type TDialogPropsType<T extends TDialogTypes> = ComponentProps<(typeof DIALOGS)[T]>;

type TDialogArguments<T extends TDialogTypes> =
  | {
      type: T;
    } & (T extends TDialogPropsTypeOptional
      ? { props?: TDialogPropsType<T> }
      : { props: TDialogPropsType<T> });

interface IDialogContextValues {
  activeDialogs: TDialogArguments<TDialogTypes>[];
  openDialog: <T extends TDialogTypes>(args: TDialogArguments<T>) => void;
  closeDialog: (type?: TDialogTypes) => void;
}

const DialogContext = createContext<IDialogContextValues>({
  openDialog: args => {
    // eslint-disable-next-line no-console
    console.warn('unimplemented dialog context', args.type);
  },
  closeDialog: type => {
    // eslint-disable-next-line no-console
    console.warn('unimplemented dialog context', type);
  },
  activeDialogs: [],
});

/**
 * The default dialog props (open, onClose) should not be passed from the openDialog function
 * Ideally they would be omitted in the prop type but the omit is not working with conditional types
 * https://stackoverflow.com/questions/56916532/difference-b-w-only-exclude-and-omit-pick-exclude-typescript
 */
const DialogProvider: FC<PropsWithChildren> = ({ children }) => {
  const [activeDialogs, setActiveDialogs] = useState<TDialogArguments<TDialogTypes>[]>([]);

  const onClose = (type?: TDialogTypes) => {
    if (type && typeof type === 'string' && type in DIALOGS) {
      setActiveDialogs(curr => curr.filter(dialog => dialog.type !== type));
    } else {
      setActiveDialogs([]);
    }
  };

  /**
   * Dialogs that are already open with the same type will be closed and replaced
   */
  const openDialog: (args: TDialogArguments<TDialogTypes>) => void = args => {
    setActiveDialogs(previous => [...previous.filter(({ type }) => type !== args.type), args]);
  };

  return (
    <DialogContext.Provider
      value={{
        activeDialogs,
        openDialog,
        closeDialog: onClose,
      }}
    >
      {activeDialogs.map((dialog, index) => {
        if (!dialog || !(dialog.type in DIALOGS) || !DIALOGS[dialog.type]) {
          // eslint-disable-next-line no-console
          console.warn('An error occurred finding the dialog component', dialog?.type);
          return <></>;
        }

        const DialogComponent = DIALOGS[dialog.type] as FC<
          TDialogArguments<typeof dialog.type>['props'] & IDefaultDialogProps
        >;
        const props: TDialogArguments<typeof dialog.type>['props'] =
          'props' in dialog && dialog.props ? dialog.props : {};

        return (
          <DialogComponent
            key={dialog.type}
            {...props}
            onClose={() => onClose(dialog.type)}
            open // Before -> isLast = activeDialogs.length - 1 === index;
          />
        );
      })}

      {children}
    </DialogContext.Provider>
  );
};

export { DialogProvider };

export default DialogContext;
